import { io } from "socket.io-client";
import config from "../config";

const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }
  if (config?.api) {
    // Strip trailing /api or /api/
    return config.api.replace(/\/api\/?$/, "");
  }
  return typeof window !== "undefined" ? window.location.origin : "http://localhost:4000";
};

const getSocketPath = () => {
  if (process.env.REACT_APP_SOCKET_PATH) {
    return process.env.REACT_APP_SOCKET_PATH;
  }
  return "/api/socket.io";
};

const SOCKET_URL = getSocketUrl();
const SOCKET_PATH = getSocketPath();

let activeCandidateRoom = null;

export const socket = io(SOCKET_URL, {
  path: SOCKET_PATH,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 20,
  reconnectionDelay: 2000,
  transports: ["polling", "websocket"],
  withCredentials: true,
});

socket.on("connect", () => {
  console.log("[WebSocket] Connected to server:", socket.id, "at", SOCKET_URL);
  if (activeCandidateRoom) {
    socket.emit("join_candidate", activeCandidateRoom);
    console.log(`[WebSocket] Re-joined candidate room on reconnect: candidate_${activeCandidateRoom}`);
  }
});

socket.on("disconnect", (reason) => {
  console.log("[WebSocket] Disconnected from server:", reason);
});

socket.on("connect_error", (err) => {
  console.warn("[WebSocket] Connection error:", err.message);
});

export const joinCandidateRoom = (candidateId) => {
  if (candidateId && socket) {
    activeCandidateRoom = candidateId;
    if (socket.connected) {
      socket.emit("join_candidate", candidateId);
      console.log(`[WebSocket] Joined candidate room: candidate_${candidateId}`);
    }
  }
};

export const leaveCandidateRoom = (candidateId) => {
  if (candidateId && socket) {
    if (activeCandidateRoom === candidateId) {
      activeCandidateRoom = null;
    }
    if (socket.connected) {
      socket.emit("leave_candidate", candidateId);
      console.log(`[WebSocket] Left candidate room: candidate_${candidateId}`);
    }
  }
};

export default socket;
